import { render, staticRenderFns } from "./inventoryDiffList.vue?vue&type=template&id=585bb29b"
import script from "./inventoryDiffList.vue?vue&type=script&lang=js"
export * from "./inventoryDiffList.vue?vue&type=script&lang=js"
import style0 from "./inventoryDiffList.vue?vue&type=style&index=0&id=585bb29b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports